import { buildClosedConfig, buildClosedOptions } from '../shared/closedConfig'

const FSMConfigContentNO = buildClosedConfig('QBFlowMachineContent')
const FSMOptionsContentNO = buildClosedOptions()

export { FSMConfigContentNO, FSMOptionsContentNO }
